import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'greenerPercentage',
  pure: true,
  standalone: false
})
export class GreenerPercentagePipe implements PipeTransform {
  transform(fn: number, ...args: any[]): any {
    return (fn * 100).toFixed(2);
  }
}
